<template>
  <section>
    <b-row>
      <b-col
        cols="12"
      >
        <estadisticas />
      </b-col>
    </b-row>

  </section>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import Estadisticas from './components/dashboard/Estadisticas.vue'

export default {
  components: {
    BRow,
    BCol,
    Estadisticas,
  },
}

</script>
